import React, { useState } from 'react';
//import { useNavigate } from 'react-router-dom';
import { doPasswordChange } from '../../../firebase/auth';
import './changepassword.css'; // Create this CSS file

const ChangePassword = () => {
    // const navigate = useNavigate();  // Comment it out if not needed
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isChanging, setIsChanging] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setErrorMessage('New password and confirm password do not match.');
            return;
        }

        if (!isChanging) {
            setIsChanging(true);
            setErrorMessage('');
            setSuccessMessage('');
            try {
                await doPasswordChange(newPassword, currentPassword); // Assuming you have this function
                setSuccessMessage('Password changed successfully!');
                // Optionally navigate to another page or clear the form
            } catch (error) {
                setErrorMessage(error.message);
            } finally {
                setIsChanging(false);
            }
        }
    };

    return (
        <div className="login-page">
            <main className="main-content">
                <div className="login-box">
                    <div className="text-center">
                        <div className="welcome-message">
                            <h3>Change Password</h3>
                        </div>
                    </div>
                    <form onSubmit={onSubmit} className="login-form">
                        <div className="form-group">
                            <label className="form-label">Current Password</label>
                            <input
                                type="password"
                                autoComplete="current-password"
                                required
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">New Password</label>
                            <input
                                type="password"
                                autoComplete="new-password"
                                required
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Confirm New Password</label>
                            <input
                                type="password"
                                autoComplete="new-password"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        {errorMessage && <span className="error-message">{errorMessage}</span>}
                        {successMessage && <span className="success-message">{successMessage}</span>}
                        <button type="submit" disabled={isChanging} className="submit-button">
                            {isChanging ? 'Changing...' : 'Change Password'}
                        </button>
                    </form>
                </div>
            </main>
        </div>
    );
};

export default ChangePassword;